<script>
import SagePaySlipPage from "@/views/Integration/Sage/PaySlip/SagePaySlipPage.vue";

export default {
    components: {SagePaySlipPage}
}
</script>

<template>
    <sage-pay-slip-page  intranet/>
</template>